import { useState, useEffect } from "react";
import { Schedule } from "../../../data/entities";
import { ScheduleService } from "../../../services";

export function useCalendarProviderSchedules(providerIds: number[]) {
  const [schedules, setSchedules] = useState<Schedule[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!providerIds || providerIds.length === 0) {
      setSchedules([]);
      return;
    }

    const fetchSchedules = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const scheduleService = new ScheduleService();
        const result = await scheduleService.getSchedulesByProviderIdsAsync(providerIds);
        setSchedules(result || []);
      } catch (err: any) {
        setError(err.message);
        setSchedules([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchedules();
  }, [providerIds.join(',')]); 

  return { schedules, isLoading, error };
}